export enum NotificationType {
  Success = 1,
  Warning,
  Error,
  Default,
  Info,
}
